module.exports = __webpack_public_path__ + "static/img/new1.632926cb.png";